export default "__VITE_ASSET__10414189__"